import React, { useEffect } from "react";
import styles from "./Hero.module.css";
import "../../styles/common.css";
import useServerQuery from "../FetchServerStats";

/**
 * Hero — большая outline-надпись INTERWORLD и единственная CTA «Начать играть» под ней.
 */
const Hero = () => {
  const serverIP = "play.interworld.fun";
  const { fetchData, data, loading } = useServerQuery();

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(serverIP);
    alert("IP скопирован: " + serverIP);
  };

  return (
    <section className={styles.hero}>
      <div className={styles.heroWrap}>
        {/* Большая надпись бренда + CTA под ней */}
        <div className={styles.stage}>
          <div className={styles.brandTitle} aria-hidden="true">
            INTERWORLD
          </div>

          <a href="/getting-started" className={styles.ctaButton}>
            <span className={styles.playIcon} aria-hidden="true">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            </span>
            <span className={styles.ctaText}>Начать играть</span>
          </a>
        </div>

        {/* Описание под героем */}
        <div className={styles.below}>
          <p className={styles.lead}>
            <span className={styles.brandAccent}>InterWorld</span> — это
            виртуальный мир Hytale с десятками ролей, режимов и активностей.
            Создавай собственную историю вместе с дружным русскоязычным сообществом.
          </p>

          <div className={styles.try}>
            <h3 className={styles.tryTitle}>Начни своё приключение</h3>
            <div className={styles.tryActions}>
              <button onClick={copyToClipboard} className={styles.pathBtn}>
                <span className={styles.pathArrowLeft}>‹</span>
                Скопировать IP
              </button>
              <a href="/getting-started" className={`${styles.pathBtn} ${styles.pathBtnPrimary}`}>
                Как начать играть
                <span className={styles.pathArrowRight}>›</span>
              </a>
            </div>
          </div>

          {/* Маленький блок статистики */}
          <div className={styles.statsRow}>
            <div className={styles.stat}>
              <span
                className={`${styles.statusDot} ${
                  data ? styles.online : styles.offline
                }`}
              />
              <span className={styles.statLabel}>
                {loading ? "Обновление..." : data ? "Сервер онлайн" : "Сервер оффлайн"}
              </span>
            </div>
            <div className={styles.statDivider} />
            <div className={styles.stat}>
              <b>{data?.Universe?.CurrentPlayers ?? 0}</b>
              <span className={styles.statLabel}>игроков сейчас</span>
            </div>
            <div className={styles.statDivider} />
            <div className={styles.stat}>
              <code className={styles.code}>{serverIP}</code>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
